<template>
  <div class="wrapper app-content">
    <div v-if="promotionLink">
      <div class="tilte-text"> 影票推广 </div>
      <div class="promote-link">
        <div class="promote-box">
          <div class="link-title">您的影票专属推广链接为：</div>
          <div>
            <div class="link"><a :href="promotionLink" target="_blank">{{ promotionLink }}</a></div>
            <div class="link-desc">将链接放于您的公众号菜单栏中，会员点击菜单就可以专属购票页面，订单结算后您将获得订单利润分佣。</div>
          </div>
        </div>
        <div class="copy-div">
          <span class="code-span" v-clipboard:copy="promotionLink" v-clipboard:success="onCopy"
            v-clipboard:error="onError">复制推广链接</span>
        </div>
      </div>
    </div>
    <div class="tilte-text"> 网站推广 </div>
    <div class="promote-link">
      <div class="promote-box">
        <div class="link-title">我的推广链接：</div>
        <div>
          <div class="link">{{ promote_link }}</div>
          <div class="link-desc">为保证推荐人关系不丢失，请复制完整的邀请链接</div>
        </div>
      </div>
      <div class="copy-div">
        <span class="code-span" v-clipboard:copy="promote_link" v-clipboard:success="onCopy"
          v-clipboard:error="onError">复制推广链接</span>
      </div>
    </div>
    <div class="table-wrapper">
      <Table border :columns="columns" :data="list" :loading="listLoading">
        <template slot-scope="{ row }" slot="action">
          <div>
            <span style="cursor: pointer;color:#3D9EFC" @click="showDetail(row)">查看详情</span>
          </div>
        </template>
      </Table>
      <div style="padding: 10px 0px">
        <Page :total="total" :current="searchForm.pageNo" show-sizer show-elevator show-total @on-change="changePage"
          @on-page-size-change="changePagesize"></Page>
      </div>
    </div>
    <Detail ref="Detail" v-show="isShowDetail"></Detail>
  </div>
</template>

<script>
import Detail from '@/views/pc/official/invite/modal/Detail'
import { getUserUUID, getPlatformUuid } from '@/utils/auth'
import { Table, Button, Page } from 'view-design'
import invite from '@/javaApi/invite'
const inviteModel = new invite()
export default {
  name: "Invite",
  components: {
    Table,
    Button,
    Page,
    Detail
  },
  data: function () {
    return {
      promote_link: location.href.replace(this.$route.path, '') + "/pc/home?invite_code=" + getUserUUID(),
      columns: [
        {
          title: '序号',
          key: 'sequence'
        },
        {
          title: '我推荐的好友',
          key: 'nickname',
        },
        {
          title: '注册时间',
          key: 'registerTimeStr'
        },
        {
          title: '已购套餐详情',
          slot: 'action',
          align: 'center',
          width: 260,
        }
      ],
      listLoading: false,
      list: [],
      total: 0,
      isShowDetail: false,
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        userUUID: getUserUUID()
      }
    }
  },
  mounted: function () {
    localStorage.setItem('inviteCode', getUserUUID())
  },
  computed: {
    promotionLink() {
      const platformUuid = getPlatformUuid() || ''
      return platformUuid != '' && platformUuid != 0 ? process.env.VUE_APP_MOVIE_PROMOTION_URL + 'yp-api/movie/wx/pub-login?platformUuid=' + platformUuid + '&type=1' : ''
    }
  },
  created() {
    this.getList(true)
  },
  methods: {
    getList(first = false) {
      this.listLoading = true
      if (first) this.searchForm.pageNo = 1
      let searchForm = Object.assign({}, this.searchForm)
      inviteModel.getInviteList(searchForm).then((response) => {
        this.listLoading = false
        let res = response.data
        if (res.code != 200) {
          this.$Message.error(res.message)
          return
        }
        this.list = this.formateData(res.data.list);
        this.total = res.data.total;
      })

    },
    formateData(data) {
      if (!data) {
        return []
      }
      if (!data.length) {
        return []
      }
      let i = 0;
      let pageNo = this.searchForm.pageNo
      let pageSize = this.searchForm.pageSize
      for (i = 0; i < data.length; i++) {
        data[i].sequence = (i + 1) + (pageNo - 1) * pageSize
      }
      return data
    },
    changePage(value) {
      this.searchForm.pageNo = value
      this.getList()
    },
    changePagesize(value) {
      this.searchForm.pageSize = value
      //如果处于第一页改变数量，则会触发changePage
      if (this.searchForm.pageNo == 1) {
        this.getList()
      }
    },
    //复制
    onCopy: function (e) {
      this.$Message.success('复制成功');
    },
    onError: function (e) {
      this.$Message.success('复制失败');
    },
    showDetail: function (row) {
      this.isShowDetail = true;
      this.$refs.Detail.init(true, row);
    }
  }
}
</script>

<style scoped>
.bg-orange {
  background: #ff8622;
}

.bg-blue {
  background: #3d9efc;
}

.bg-pink {
  background: #ff4f76;
}

.font-16 {
  font-size: 16px;
}

.font-14 {
  font-size: 14px;
}

.tilte-text {
  font-size: 18px;
  color: #222222;
  text-align: left;
  font-weight: bold;
}

.wrapper {
  width: 100%;
  font-size: 12px;
}

.wrapper .promote-link {
  background: #FAFAFA;
  border-radius: 2px;
  padding: 10px 12px;
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  text-align: center;
  margin-bottom: 31px;
}

.wrapper .promote-link .promote-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  text-align: justify;
}

.wrapper .promote-link .promote-box .link-title {
  padding-right: 5px;
  font-size: 14px;
}

.link {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 13px;
  color: #3D9EFC;
}

.link-desc {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 12px;
  color: #999999;
  padding-top: 6px;
}

.copy-div {
  padding-top: 3px;
  cursor: pointer;
}

.copy-div .code-span {
  display: block;
  width: 122px;
  height: 36px;
  line-height: 36px;
  background: #FF8622;
  border-radius: 2px;
  color: #FFFFFF;
  font-size: 13px;
}

.ivu-date-picker-rel {
  margin: 6px 0;
}

.ivu-table {
  background: #FFFFFF;
  border: 1px solid #EEEEEE;
  border-radius: 2px;
}

.table-wrapper .ivu-table-header th {
  background-color: #FCFAF8 !important;
}

.table-wrapper .ivu-table-header th .ivu-table-cell {
  color: #222222 !important;
}

.table-wrapper .ivu-table-wrapper-with-border {
  border: none;
}

.table-wrapper .ivu-table-wrapper-with-border {
  border-radius: 0px;
  border-color: #FFFFFF !important;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/official/invite/Index.vue